const uniqueArrayOfObjectByKey = (array, key)=>{

    return array.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[key]).indexOf(obj[key]) === pos;
    });

}

/**
 * Use this helper to remove array of objects if all all keys and values are considered.
 * It's commonly used and clever way, by first converting each entry to strings and then back to objects
 * @param arr
 * @returns {unknown[]}
 */
const uniqueArrayOfObject = (array) => {
    return [...new Set(
        array.map(el => JSON.stringify(el))
    )].map(e => JSON.parse(e));
}

/**
 * Simple numeric sort
 */
const sortNumeric = (items)=>{
    items = items.sort((a, b) => a - b);
    return items;
}

export {
    uniqueArrayOfObjectByKey,
    uniqueArrayOfObject,
    sortNumeric
}